import React from 'react';
import { Box, TextField } from '@mui/material';

import { InputFieldV2 } from 'components/common/form-controls';
import autocompleteStyles from 'components/common/form-controls/InputFieldV2/Autocomplete/autocomplete.style';
import { dropdownStyles } from 'styles/dropdown';

import styles from './instaTaskSideBarItemAutocomplete.styles';

// User should provide "options", "value" and "onChange" in the item properties
// Example:
// {
//   id: 'unique-field-id',
//   type: 'autocomplete',
//   title: 'My Autocomplete',
//   value: { text: 'Option 5', value: '5' },
//   options: [
//     { text: 'Option 1', value: '1' },
//     { text: 'Option 2', value: '2' },
//     { text: 'Option 3', value: '3' },
//     { text: 'Option 4', value: '4' },
//     { text: 'Option 5', value: '5' },
//   ],
//   onChange: () => {},
// }

const InstaTaskSideBarItemAutocomplete = ({ item }) => {
  const itemOptions = item?.options || [];

  const itemValue = item?.value || '';

  const itemOnChange = item?.onChange;

  const handleOnChange = (value) => {
    if (itemOnChange) {
      itemOnChange(value);
    }
  };

  const renderOption =
    item?.renderOption ||
    ((autoCompleteProps, option) => {
      return (
        <Box
          component="li"
          {...autoCompleteProps}
          key={option.value}
          sx={{
            ...dropdownStyles.multiSelectItem,
            ...autocompleteStyles.selectItem,
            opacity: option.disabled ? 0.6 : 1,
            pointerEvents: option.disabled ? 'none' : 'auto',
          }}
        >
          {option.icon} {option.text || option.label || ''}
        </Box>
      );
    });

  const renderInput = (params) => {
    const startAdornment = item?.getStartAdornment?.(itemValue);
    return (
      <TextField
        variant="outlined"
        {...params}
        sx={styles.textfield}
        slotProps={{
          input: {
            ...params.InputProps,
            ...(startAdornment && { startAdornment }),
            endAdornment: params.InputProps.endAdornment,
          },
        }}
      />
    );
  };

  return (
    <InputFieldV2
      type="autocomplete"
      options={itemOptions}
      value={itemValue}
      renderOption={renderOption}
      renderInput={renderInput}
      styles={{ textfield: styles.textfield }}
      onChange={(value) => handleOnChange(value)}
    />
  );
};

export default InstaTaskSideBarItemAutocomplete;
